import FooterSection from "./FooterSection";
import StaticBanner from "./StaticBanner";
import HeaderSection from "./HeaderSection";
import {dateToTimestamp, timestampToDate} from "../utilities";
import {INSTALLATION_ALERT_STATUS_DISCONNECTED} from "../api/wimhome-api";
import {useTranslation} from "react-i18next";
import React from "react";
import {InstallationsContext, MqttContext} from "./App";
import cloneDeep from "lodash/cloneDeep";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload, faEnvelope, faEnvelopeOpen, faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import '../css/reports.css';
// import dateAdd from "date-fns/add";
import dateSub from "date-fns/sub";
import PermanentAlertsBar from "./PermanentAlertsBar";
import {SITE_LINKS} from "../Contants";

export default function ReportsPage({ history, currRoute }) {
  const { t , i18n } = useTranslation();
  let mainContentRef = React.createRef();
  const {
    selectedInst,
    installations,
    postInstallationMarkReportsSeen,
    loadInstallationReports,
    installationReports,
    setInstallationReports,
    downloadInstReport,
    countUnreadReports
  } = React.useContext(InstallationsContext);

  const { mqttStatus } = React.useContext(MqttContext);
  const selectedInstallationData =
      selectedInst && installations ? installations[selectedInst] : null;

  async function downloadReport(id) {
    try {
      const res = await downloadInstReport(selectedInst, id);
      if(res !== true) {
        confirmAlert({
          title: `${t('Error')}`,
          message: `${t('reports.cannotDownload')}`,
          buttons: [
            {
              label: `${t('OK')}`,
              onClick: () => {}
            }
          ],
          overlayClassName: "overlay-confirm-alert-over-all"
        });
        return;
      }
      setInstallationReports((cur) => {
        let newReps = cloneDeep(cur);
        for(let repTypeIdx in newReps) {
          for(let rep of newReps[repTypeIdx].reports) {
            if(rep.id === id) {
              rep.shown = true;
            }
          }
        }
        return newReps
      })
    } catch(ex) {
      console.log(ex)
      confirmAlert({
        title: `${t('Error')}`,
        message: `${t('reports.cannotDownload')}`,
        buttons: [
          {
            label: `${t('OK')}`,
            onClick: () => {}
          }
        ],
        overlayClassName: "overlay-confirm-alert-over-all"
      });
    }
  }

  async function markAllAsDownloaded(datetime) {
    try {
      const res = await postInstallationMarkReportsSeen(selectedInst, dateToTimestamp(datetime));
      if(res !== true) {
        confirmAlert({
          title: `${t('Error')}`,
          message: `${t('reports.cannotMarkReports')}`,
          buttons: [
            {
              label: `${t('OK')}`,
              onClick: () => {}
            }
          ],
          overlayClassName: "overlay-confirm-alert-over-all"
        });
        return;
      }
      await loadInstallationReports(selectedInst);
    } catch(ex) {
      console.log(ex)
      confirmAlert({
        title: `${t('Error')}`,
        message: `${t('reports.cannotMarkReports')}`,
        buttons: [
          {
            label: `${t('OK')}`,
            onClick: () => {}
          }
        ],
        overlayClassName: "overlay-confirm-alert-over-all"
      });
    }
  }

  function confirmMarkAllAsDownloaded() {
    confirmAlert({
      title: `${t('reports.confirmTitle')}`,
      message: `${t('reports.confirmMarkAllAsRead')}`,
      buttons: [
        {
          label: `${t('Yes')}`,
          onClick: async () => {
            await markAllAsDownloaded(new Date());
          }
        },
        {
          label: `${t('No')}`,
          onClick: () => {}
        }
      ],
      overlayClassName: "overlay-confirm-alert-over-all"
    });
  }

  if(selectedInst == null) {
    history.push(SITE_LINKS.INSTALLATIONS);
    return null;
  }

  return (
      <>
        <HeaderSection
            currRoute={currRoute}
            mainContentRef={mainContentRef}
            mqttStatus={mqttStatus}
            selectedInst={selectedInst}
        />
        <section className="main-content" ref={mainContentRef} style={{ lineHeight: 1 }}>
          <PermanentAlertsBar />
          {selectedInstallationData?.status === INSTALLATION_ALERT_STATUS_DISCONNECTED && (
              <StaticBanner
                  backgroundColor='#d9534f'
                  color='white'
                  icon='exclamation-triangle'
                  message={`${t('statusPage.disconnectionAlertBanner')} ${timestampToDate(
                      selectedInstallationData?.lastStatusUpdate
                  ).toLocaleString(i18n.language)}`}
              />
          )}
          <div className="main-inner-div">
            <div className="content-wrap">
              {installationReports && installationReports.map((report, reportId) => {
                return (
                    <div key={reportId}>
                      <h2>
                        {`${report.name} [${countUnreadReports(report.name)}]`}
                        <span className="edit-inst-info" onClick={(e) => {e.stopPropagation(); confirmMarkAllAsDownloaded()}}>
                          <FontAwesomeIcon className="ticketing-entry-icon" icon={faCheckDouble} title={t('reports.markAllAsRead')} />
                        </span>
                      </h2>
                      <hr/>
                      <div>
                        <table className={'reports-table'}>
                          <thead>
                          <tr>
                            <th>{t('reports.read')}</th>
                            <th>{t('reports.startDate')}</th>
                            <th>{t('reports.endDate')}</th>
                            <th>{t('reports.download')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {report.reports.map((r) => {
                            let rEnd =  timestampToDate(r.end)
                            if(rEnd.getHours() === 0 && rEnd.getMinutes() === 0 && rEnd.getSeconds() === 0)
                              rEnd = dateSub(rEnd, { days: 1 })
                            return <tr key={r.id}>
                              {!r.shown && <td className={'icon'} title={t('reports.notRead')}><FontAwesomeIcon icon={faEnvelope}/></td>}
                              {r.shown && <td className={'icon'} title={t('reports.read')}><FontAwesomeIcon icon={faEnvelopeOpen}/></td>}
                              <td className={'date'}>{`${timestampToDate(r.start).toLocaleDateString(i18n.language)}`}</td>
                              <td className={'date'}>{`${rEnd.toLocaleDateString(i18n.language)}`}</td>
                              <td
                                  className={'icon download'}
                                  onClick={() => downloadReport(r.id)}
                                  title={t('reports.download')}
                              ><FontAwesomeIcon icon={faDownload}/></td>
                            </tr>
                          })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                )
              })}
            </div>
          </div>
        </section>
        <FooterSection />
      </>
  );
}